import React from "react";
import {Button, Checkbox, Col, Dropdown, Menu, Popover, Row} from "antd";
import {EditOutlined, EllipsisOutlined, FileTextOutlined} from "@ant-design/icons";
import {formatDateShort, formatGrade} from "@lib/format";
import {DiamondIcon, FlameIcon, StorageBoxOutlineIcon} from "@components/icons/Icons";
import {FmvPrice} from "@components/fmv-price";
import {KeyIssueBadge} from "@components/key-issue-badge";

const WishlistListItemMobile = ({
    item,
    showEditMultiple,
    isSelected,
    toggleSelected,
    bookCover,
    issueDate,
    showValueRibbon,
    setShowEdit,
    setAddIssueId,
    wishlistIssueRemove,
    windowDimensions,
}) => {

    return (
        <Row className="grid-list-item">
            {showEditMultiple && (
                <Col  className="col-cbx">
                    <Checkbox
                        className="checkbox"
                        checked={isSelected}
                        onChange={() => toggleSelected(item.id)}
                    />
                </Col>
            )}
            <Col >
                <div className="col-image">
                    {bookCover}
                </div>
            </Col>

            <Col className="grid-list-content-small-screen">
                <Row>
                    <Col span={12} className="flex-row" >
                        <div className="valueBadges">
                            {item.is_key && (<KeyIssueBadge keyInfo={item.key_info} windowDimensions={windowDimensions} isLargeScreen={false} biggerClass={true}/>)}
                            {item.is_hot && (<div className="valueBadge bigger hotIssue isActive"><FlameIcon /></div>)}
                            {item.is_rare && (<div className="valueBadge bigger rareIssue isActive"><DiamondIcon /></div>)}
                        </div>
                    </Col>

                    <Col span={12} className="no-wrap" >
                        <div className="col-right">
                            {item.notes && (
                                <Popover content={item.notes} trigger={["click"]}>
                                    <Button size={"small"} className="greyButton mar-left-5" >
                                        <FileTextOutlined className="icon12 iconDarkGrey" />
                                    </Button>
                                </Popover>
                            )}

                            <Button type={"text"} className="greyButton mar-left-5" size={"small"} onClick={() => {
                                setShowEdit(true);
                            }} >
                                <EditOutlined className="icon12 iconDarkGrey" />
                            </Button>

                            <Dropdown className="greyButton selectButton" trigger={["click"]} overlay={(
                                <Menu >
                                    <Menu.Item key={0} onClick={() => setAddIssueId(item.id)}>Add To Collection</Menu.Item>
                                    <Menu.Item key={1} onClick={() => wishlistIssueRemove([item.id])} >Remove from Wishlist</Menu.Item>
                                    <Menu.Item key={2}><a href={`/issue/${item.slug}`}>Go to Price Guide</a></Menu.Item>
                                    <Menu.Item key={3}><a href={`/marketplace/?issue_id=${item.id}`}>Buy in Marketplace</a></Menu.Item>
                                </Menu>
                            )}>
                                <Button className="greyButton mar-left-5" size={"small"}>
                                    <EllipsisOutlined className="font-12 iconDarkGrey" />
                                </Button>
                            </Dropdown>
                        </div>
                    </Col>
                </Row>

                <Row className="item-title">
                    <Col span={24} className="flex-col">
                        <div className="break-spaces">
                            <a href={`/issue/${item.slug}`}>
                                <div className="titleLink font-16">{item.series_title}: {item.issue_number}</div>
                            </a>
                            <span className="font-12 font-normal">
                                {item.is_variant ? item.variant_name : 'Regular'}<br/>
                                {item.publisher} | {formatDateShort(issueDate)}
                            </span>
                        </div>
                    </Col>
                </Row>

                <Row className="font-12">
                    <Col span={24}>
                        <div className={"graded-by rounded-row " + (!(item.graded_by && item.graded_by.toUpperCase() !== 'RAW') ? 'raw' : 'slab')}>
                            Desired Grade
                            <span className="float-right pad-right-20">
                                {item.graded_by ? item.graded_by.toUpperCase() : 'RAW'}{' | '+formatGrade(item.grade)}
                            </span>
                        </div>
                    </Col>
                </Row>

                <Row className="font-12">
                    <Col span={8} className={'flex-col flex-align-center fmv-col right-line'}>
                        <span className="text-grey">Est. FMV</span>
                        <div className="flex-align-center">
                            {showValueRibbon ? (
                                <FmvPrice
                                    prefix={(item.is_most_common_value && item.most_common_grade) ? ('('+formatGrade(item.most_common_grade)+') ') : null}
                                    value={item.value}
                                    stale={item.stale}
                                />
                            ):(
                                <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                            )}
                        </div>
                    </Col>
                    <Col span={8} className={'flex-col flex-align-center fmv-col right-line'}>
                        <span className="text-grey">Qty.</span>
                        {item.wishlist_qty ? item.wishlist_qty : 1}
                    </Col>
                    <Col span={8} className={'flex-col flex-align-center fmv-col'}>
                        <a href={`/marketplace/?issue_id=${item.id}`}>Buy Now</a>
                    </Col>
                </Row>
            </Col>
        </Row>
    );

};

export default WishlistListItemMobile;